import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TestTransitionContext = createContext({});

export const PUBLIC_ROUTES = {
    home: '/home',
    chisiamo: '/chi-siamo',
    progetti: '/progetti',
    finanza: '/finanza-di-progetto',
    lavora: '/lavora-con-noi',
    contatti: '/contatti',
};

export const HEADER_H = {
    [PUBLIC_ROUTES.chisiamo]: 363,
    [PUBLIC_ROUTES.progetti]: 166,
    [PUBLIC_ROUTES.finanza]: 363,
    [PUBLIC_ROUTES.lavora]: 363,
    [PUBLIC_ROUTES.contatti]: 363,
    '/test/chi-siamo': 363,
    '/test/finanza-di-progetto': 363,
    '/test/progetti': 166,
    '/test/lavora-con-noi': 363,
    '/test/contatti': 363,
};

export function TestTransitionProvider({ children }) {
    const [phase, setPhase] = useState('idle');
    const [targetRoute, setTargetRoute] = useState(null);
    const timerRef = useRef(null);
    const navigateTimerRef = useRef(null);
    const navigate = useNavigate();

    const clearTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (navigateTimerRef.current) {
            clearTimeout(navigateTimerRef.current);
            navigateTimerRef.current = null;
        }
    };

    const navTo = useCallback((route) => {
        clearTimer();
        setTargetRoute(route);
        setPhase('morphToHeader');
        navigateTimerRef.current = setTimeout(() => {
            navigate(route);
            navigateTimerRef.current = null;
        }, 80);
        timerRef.current = setTimeout(() => {
            setPhase('idle');
            setTargetRoute(null);
        }, 1720);
    }, [navigate]);

    const openMenu = useCallback((options = {}) => {
        clearTimer();
        setTargetRoute(null);
        setPhase(options.fromHeader ? 'menuReady' : 'menu');
    }, []);

    const triggerMenuSvg = useCallback(() => {
        clearTimer();
        setTargetRoute(null);
        setPhase('openFromHeader');
        timerRef.current = setTimeout(() => {
            navigate(PUBLIC_ROUTES.home);
            setPhase('menuReady');
        }, 1250);
    }, [navigate]);

    const exitTest = useCallback(() => {
        clearTimer();
        setPhase('idle');
        setTargetRoute(null);
    }, []);

    return (
        <TestTransitionContext.Provider value={{
            phase,
            targetRoute,
            navTo,
            openMenu,
            triggerMenuSvg,
            exitTest,
        }}>
            {children}
        </TestTransitionContext.Provider>
    );
}

export function useTestTransition() {
    return useContext(TestTransitionContext);
}

export default TestTransitionContext;
